import {colors} from '@/constants'
import React from 'react'
import {Stack, Typography} from '@mui/material'
import TransCustom from '@/components/UI/i18next'

const Index = ({text}: {text: string}) => {
  return (
    <>
      <Stack
        boxSizing="border-box"
        width="100%"
        gap="40px"
        padding="40px"
        justifyContent="space-between">
        <TransCustom
          variant="h1"
          i18nKey="1230"
          color={colors.yellow}
          textAlign="center"
        />
        <Stack alignItems="center" gap="40px">
          <Typography variant="body2">{text}</Typography>
        </Stack>
      </Stack>
    </>
  )
}

export default Index
